import {Answer} from 'Models'
import {calcSimplePoints} from '../_common/pointsCalculationHelper';

export const calculatePoints = calcSimplePoints